import { createContext } from "react"

type Theme = "dark" | "light" | "system"

type ThemeProviderState = {
  /** The stored choice, which may be "system". */
  theme: Theme
  /** What is actually painted: "system" resolved against the OS preference. */
  resolvedTheme: "dark" | "light"
  setTheme: (theme: Theme) => void
}

const initialState: ThemeProviderState = {
  theme: "system",
  resolvedTheme: "light",
  setTheme: () => null,
}

export const ThemeProviderContext = createContext<ThemeProviderState>(initialState)

export type { Theme, ThemeProviderState }
